export const TEST_ID = 'sendToDroneControl';

export const SEND_BUTTON_TEST_ID = 'sendToDroneControlSendButton';

export const RESULT_TEST_ID = 'sendToDroneControlResult';
